import createIcon from '../../createIcon';

/**
 * @component @name Tour
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg2VjJINFYyMkg2VjE0SDIwTDE4IDlMMjAgNFpNMTQgOUMxNCAxMC4xIDEzLjEgMTEgMTIgMTFDMTAuOSAxMSAxMCAxMC4xIDEwIDlDMTAgNy45IDEwLjkgNyAxMiA3QzEzLjEgNyAxNCA3LjkgMTQgOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tour = createIcon('Tour', [
  [
    'path',
    {
      d: 'M20 4H6V2H4V22H6V14H20L18 9L20 4ZM14 9C14 10.1 13.1 11 12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9Z',
      key: '17ahw0',
    },
  ],
]);

export default Tour;
